import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddProduct = ({ product, value,setIsPopup,id }) => {
  const navigate = useNavigate();
  const [name, setName] = useState(product || "");
  const [image, setImage] = useState();
  const [price, setPrice] = useState(value);
  const [loading,setLoading] = useState(false);

  const addProduct = async () => {
    const newProduct = new FormData();
    setLoading(true);

    newProduct.append("name", name);
    newProduct.append("image", image);
    newProduct.append("price", price);
    if(product){
      try {
        const response = await axios.post(
          `https://rbbackend.onrender.com/products/${id}`,
          newProduct
        );
        console.log(response);
        if(setIsPopup){
          setIsPopup(false);
        }
    setLoading(false);

       
        alert("Product Added Successfully!");
        navigate("/product");
      } catch (error) {
    setLoading(false);

        console.error("Error adding product:", error);
      }

    }else{
      try {
        const response = await axios.post(
          "https://rbbackend.onrender.com/products",
          newProduct
        );
        console.log(response);
    setLoading(false);
        
        alert("Product Added Successfully!");
        navigate("/cms");
      } catch (error) {
    setLoading(false);

        console.error("Error adding product:", error);
      }

    }

   
  };

  return (
    <>
  {loading ? <div className="d-flex align-items-center justify-content-center" style={{height:'60vh'}}>Loading ...</div> :  <div
      className="mx-auto my-5 productAdd flex-column"
      style={{ position: "sticky", padding: "5%" }}
    >
      <h2>Add Product</h2>
      <div className="d-flex flex-column mb-4">
        <label htmlFor="name">Name</label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="d-flex flex-column mb-4">
        <label htmlFor="price">Description</label>
        <input
          type="text"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
      </div>
      <div className="d-flex flex-column">
        <label htmlFor="image" className="mb-3">
          Upload Image
        </label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => setImage(e.target.files[0])}
        />
      </div>

      <button className="mt-5" onClick={() => addProduct()}>
        Add
      </button>
    </div>}
    </>
  );
};

export default AddProduct;
